import { create } from 'zustand';
import { useEffect } from 'react';

export const DASHBOARD_REFRESH_STORAGE_KEY = 'aha-dashboard-refresh';

type DashboardRefreshStore = {
  revision: number;
  requestRefresh: () => void;
};

/** Allows mutations outside the Home page to invalidate its dashboard read model. */
export const useDashboardRefreshStore = create<DashboardRefreshStore>(
  (set) => ({
    revision: 0,
    requestRefresh: () => {
      set((state) => ({ revision: state.revision + 1 }));
      try {
        // The desktop detail opens in another tab; only send an invalidation.
        window.localStorage.setItem(
          DASHBOARD_REFRESH_STORAGE_KEY,
          `${Date.now()}:${Math.random()}`
        );
      } catch {
        // Unavailable storage must not turn a successful submission into an error.
      }
    }
  })
);

export function useDashboardRefreshSync() {
  useEffect(() => {
    const onStorage = (event: StorageEvent) => {
      if (event.key !== DASHBOARD_REFRESH_STORAGE_KEY || !event.newValue)
        return;
      // Do not broadcast received invalidations back to the submitting tab.
      useDashboardRefreshStore.setState((state) => ({
        revision: state.revision + 1
      }));
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);
}
